import React from 'react';
import {base} from '../helper/base-helper.js';
import {
  Button,
  Container,
  Divider,
  Icon,
  Form,
  Header,
  Message,
  Segment
} from 'semantic-ui-react';

class Auth extends React.Component {
  constructor(props) {
    super();

    this.authenticate = this.authenticate.bind(this);
    this.authEmailPassword = this.authEmailPassword.bind(this);
    this.authHandler = this.authHandler.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.resetPassword = this.resetPassword.bind(this);

    this.renderSignUpForm = this.renderSignUpForm.bind(this);
    this.renderLogInForm = this.renderLogInForm.bind(this);
    this.renderSignUpContainer= this.renderSignUpContainer.bind(this);
    this.renderLoading= this.renderLoading.bind(this);
    this.renderPasswordReset= this.renderPasswordReset.bind(this);

    this.defaultError = { code: 'Sorry an Error occured',
                          message: 'Please try again' };

    this.state = {
      isLoading: false,
      showSignUp: true,
      showReset: false,
      formErrors: {
        email: false,
        pass: false,
        passRe: false,
        displayErrMsg: false,
        errMsgContent: []
      }
    }
  }

  authenticate(provider) {
    this.setState({
      isLoading: true
    })
    base.authWithOAuthPopup(provider, this.authHandler)
  }

  authEmailPassword(email, pass) {
    base.authWithPassword({
      email    : email,
      password : pass
    }, this.authHandler);

  }

  authHandler(err, authData) {
    if(authData) {
      this.setState({
        isLoading: false
      })
    }
    else if (err) {
      this.errorHandler(err);
    };
  }

  errorHandler(errObj = this.defaultError) {
    //trying to prune the size of the monster errors until fix (TODO)!
    const errorMsg = (typeof errObj.message === 'string')
    ? errObj.message.slice(0,80)
    : errObj.message;

    switch (errObj.code) {
      case 'auth/user-disabled':
        this.setState({
        isLoading: false,
        formErrors: {
          displayErrMsg: true,
          errMsgContent: [errorMsg]
        }
        });
        break;
      case 'auth/account-exists-with-different-credential':
        this.setState({
        isLoading: false,
        formErrors: {
          email: true,
          displayErrMsg: true,
          errMsgContent: [errorMsg]
        }
        });
        break;
      case 'auth/email-already-in-use':
        this.setState({
        isLoading: false,
        formErrors: {
          email: true,
          displayErrMsg: true,
          errMsgContent: [errorMsg]
        }
        });
        break;
        case 'auth/invalid-email':
          this.setState({
          isLoading: false,
          formErrors: {
            email: true,
            displayErrMsg: true,
            errMsgContent: [errorMsg]
          }
          });
          break;
        case 'auth/weak-password':
          this.setState({
          isLoading: false,
          formErrors: {
            pass: true,
            passRe: true,
            displayErrMsg: true,
            errMsgContent: [errorMsg]
          }
          });
          break;
        case 'passNoMatch':
          this.setState({
          isLoading: false,
          formErrors: {
            displayErrMsg: true,
            pass: true,
            passRe: true,
            errMsgContent: ['Passwords didn\'t match. Try it again, tiger.']
          }
          });
          break;
        default:
        this.setState({
          isLoading: false,
          formErrors: {
            displayErrMsg: true,
            errMsgContent: [errorMsg]
          }}
        );
      }
    }

  createEmailUser(event) {
    const pass = event.target.pass.value;
    const passRe = event.target.passRe.value;
    event.preventDefault();

    if(pass !== passRe){
      this.errorHandler({code: 'passNoMatch'})
      return;
    }

    base.createUser({
      email: event.target.email.value,
      password: event.target.pass.value
    }, this.authHandler);
  }

  resetPassword(email) {
    console.log('resetting: ', email);
    base.resetPassword({
      email: email
    }, console.log);
  }

  renderSignUpForm() {
    const errorObj = this.state.formErrors;
    return (
      <Form onSubmit={(e) => this.createEmailUser(e)}>
        <Divider section horizontal>or Sign-Up</Divider>
        <Form.Input name='email' label='Email' placeholder='bugs@acme.com' error={errorObj.email} />
        <Form.Input name='pass' label='Password' placeholder='Choose a Password' type='password' error={errorObj.pass}/>
        <Form.Input name='passRe' placeholder='Retype Password' type='password' error={errorObj.passRe}/>
        {(errorObj.displayErrMsg)
          ? <Message
            negative
            className='errorMsg'
            list={errorObj.errMsgContent}
          />
          : ''
        }
        <Button.Group fluid >
          <Button
            basic
            color='grey'
            type='button'
            onClick={(e) => {
              e.preventDefault();
              this.props.handleCancel(e);
            }}
            >
            Not Now
          </Button>
          <Button primary type='submit' >Sign Up</Button>
        </Button.Group>
      </Form>
    );
  }

  renderLogInForm() {
    const errorObj = this.state.formErrors;
    return (
      <Form onSubmit={ (event) => {
        event.preventDefault();
        this.authEmailPassword(event.target.email.value, event.target.pass.value)
      }}>
        <Divider section horizontal>Log-In via email</Divider>
        <Form.Input name='email' label='Email' placeholder='bugs@acme.com' />
        <Form.Group className='formGroup'>
          <Form.Input name='pass' label='Password' placeholder='Your Password' type='password'/>
          <Form.Button
            basic
            size='mini'
            type='button'
            onClick={(e) => {
              e.preventDefault();
              this.setState({showReset: true})
            }} >
            Forgot {<br/>} Password
          </Form.Button>
        </Form.Group>
        <Divider hidden />
        {(errorObj.displayErrMsg)
          ? <Message
            negative
            className='errorMsg'
            list={errorObj.errMsgContent}
          />
          : ''
        }
        <Button.Group fluid >
          <Button
            basic
            color='grey'
            onClick={ (e) => {
              e.preventDefault();
              this.setState({showSignUp: (!this.state.showSignUp)})
            }}>
          Back </Button>
          <Button
            primary
            type='submit'
            >Log In</Button>
        </Button.Group>
      </Form>
    );
  }

  renderSignUpContainer() {
    return (
      <div className='signUpContainer ui text container'>
        <Container textAlign='center'>
          <Header as='h5' content='Log in using: '/>
          <Button circular onClick={ () => this.authenticate('facebook') } color='facebook' icon='facebook'/>
          <Button circular onClick={ () => this.authenticate('twitter') } color='twitter' icon='twitter' />
          <Button circular onClick={ () => this.authenticate('github') } color='black' icon='github' />
          <Button circular onClick={ () => this.authenticate('google') } color='red' icon='google' />
          <span className='mailBtnSeparator'>&middot;</span>
          <Button
            circular
            color='grey'
            icon='mail'
            onClick={ () => this.setState({showSignUp: (!this.state.showSignUp)}) }
          />
        </Container>
        {(this.state.showSignUp) ? this.renderSignUpForm() : this.renderLogInForm()}
      </div>
    );
  }

  renderLoading() {
    return (
      <Container className='signUpContainer ui text container' textAlign='center'>
        <Divider hidden />
        <Icon loading color='blue' size='huge' name='notched circle' />
        <Message header='Authentication Loading...'/>
      </Container>
    )
  }

  renderPasswordReset(mail = '') {
    return (
      <Form
        className='signUpContainer ui text container'
        onSubmit={(e) => {
          return this.resetPassword(e.target.email.value);
        }}>
        <Header as='h4'>Please reset your password below:</Header>
        <Form.Input name='email' label='Email' />
        <Button.Group fluid>
          <Button basic type='button' color='grey'
            onClick={() => this.setState({showReset: false})} >
            Back
          </Button>
          <Button negative type='submit' >Reset Password</Button>
        </Button.Group>
        <Segment color='orange'>
          Please check your inbox. We did send you a reset mail.
          <br/> No email? Check your spam folder.
        </Segment>
      </Form>
    );
  }

  render() {
    return (
      <div>
        {(this.state.showReset) ? this.renderPasswordReset()
          : (this.state.isLoading && !this.state.showReset)
            ? this.renderLoading()
            : this.renderSignUpContainer()}
      </div>
    );
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/components/Auth.js